import { Component, Inject, Renderer2, PLATFORM_ID, OnInit } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { environment } from 'libs/core/environments/environment';
import { PrimeNGConfig } from 'primeng/api';


@Component({
  selector: 'icom-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less'],
})
export class AppComponent   implements OnInit {
  constructor(
    private renderer: Renderer2,
    private primengConfig: PrimeNGConfig,
    @Inject(PLATFORM_ID) private platformId: any
  ) {
    if (isPlatformBrowser(this.platformId)) {
      this.updateHeaderConfig();
    }
  }

  ngOnInit() {
    this.primengConfig.zIndex = {
        modal: 1100,    // dialog, sidebar
        overlay: 1000,  // dropdown, overlaypanel
        menu: 1000,     // overlay menus
        tooltip: 1100   // tooltip
    };
}

  updateHeaderConfig() {
    console.log(environment)
    this.renderer.setProperty(
      document.querySelector('title'),
      'textContent',
      (environment as any).title || 'ahihi'
    );

    this.renderer.setProperty(
      document.querySelector('link[rel="icon"]'),
      'href',
      (environment as any).favicon ?? ''
    );
  }
  
}
